export enum HandlerName {
  GetSessionInfo = "getSessionInfo",
  ToNamed = "toNamed",
  GetClientInfo = "getClientInfo",
  GetUserInfo = "getUserInfo",
  GetToken = "getToken",
  OpenSampleAuthorize = "openSampleAuthorize",
  JoinAdTask = "joinAdTask",
  Login = "login",
  WebViewControl = "webViewControl",
  GoBackAdTaskReload = "goBackAdTaskReload",
  OpenWithNewWebView = "openWithNewWebView",
  OpenWithExternalBrowser = "openWithExternalBrowser",
  PageControl = "pageControl",
  AdTaskRequirementsCheck = "adTaskRequirementsCheck",
}

export enum HandlerResultCode {
  Success = 0,
  Cancel = 3,
}

export enum PageControlActionName {
  Close = "close",
}

export enum AdTaskRequirementsCheckType {
  Gmv = "gmv",
  Views = "views",
}
